export default [
  {
    path: "/cnpj",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "cnpjs_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Cnpjs", to: "cnpjs_list" }],
          permission: "cnpj:view",
          title: "Cnpjs",
        },
      },
      {
        name: "cnpjs_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Cnpjs", to: "cnpjs_list" }],
          permission: "cnpj:create",
          title: "Cnpjs - Cadastro",
        },
      },
      {
        name: "cnpjs_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Cnpjs", to: "cnpjs_list" }],
          permission: "cnpj:edit",
          title: "Cnpjs - Edição",
        },
      },
    ],
  },
];
